import { render, staticRenderFns } from "./SchoolStaffAwayApplication.vue?vue&type=template&id=6afdfa3c&scoped=true&"
import script from "./SchoolStaffAwayApplication.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffAwayApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdfa3c",
  null
  
)

export default component.exports